export const applyMask = (
  value: string,
  maskType: string
) => {
  if (!value) return "";

  switch (maskType) {

    case "Visible":
      return value;

    case "Hidden":
      return "*".repeat(value.length);

    // LEFT visible, RIGHT hidden
    case "Left":
      return (
        value.slice(0, 4) +
        "*".repeat(Math.max(value.length - 4, 0))
      );

    // RIGHT visible, LEFT hidden
    case "Right":
      return (
        "*".repeat(Math.max(value.length - 4, 0)) +
        value.slice(-4)
      );

    // START + END visible, MIDDLE hidden
    case "Middle":
      if (value.length <= 4) {
        return "*".repeat(value.length);
      }

      return (
        value.slice(0, 2) +
        "*".repeat(value.length - 4) +
        value.slice(-2)
      );

    default:
      return "*".repeat(value.length);
  }
};